export default "__VITE_ASSET__BV34yZdU__"